export const SET_STATUS_FILTERS = 'SET_STATUS_FILTERS'
